<template>
    <vx-modal v-model:visible="visible" size="sm" padding="standard">
        <template v-slot:header>Detach number</template>
        <template v-slot:subheader>{{ formatPhoneNumber(props.phoneNumber) }} · {{ props.campaignId }}</template>

        <div class="text-sm text-slate-800">
            Traffic from this number is charged at the unregistered rate once the order completes; attach it to another
            campaign first if it keeps sending.
        </div>

        <template v-slot:footer>
            <div class="flex flex-col-reverse gap-4 lg:flex-row">
                <vx-button
                    @click="visible = false"
                    type="button"
                    class="grow lg:w-20 lg:grow-0"
                    size="lg"
                    color="muted"
                >
                    Cancel
                </vx-button>
                <vx-button
                    @click="confirm()"
                    data-test="confirm-detach"
                    :loading="submitting"
                    type="button"
                    class="grow"
                    size="lg"
                    color="danger"
                >
                    Detach
                </vx-button>
            </div>
        </template>
    </vx-modal>
</template>

<script lang="ts" setup>
import { VxButton, VxModal } from '@voxie/frontend-components';
import { ref } from 'vue';
import { formatPhoneNumber } from '~/components/filters';
import { useToasted } from '~/composables/useToasted';
import { adminTenDlcRegistrationClient } from '~/services';
import type { BandwidthTnOptionOrder } from '~/services/adminTenDlcRegistrationClient.types';
import { catchRequestError } from '~/utils/request';

const props = defineProps<{ campaignId: string; phoneNumber: string }>();
const emit = defineEmits<{ placed: [order: BandwidthTnOptionOrder] }>();
const visible = defineModel<boolean>('visible', { default: false });

const toasted = useToasted();

const submitting = ref(false);

const confirm = async () => {
    if (submitting.value) {
        return;
    }

    submitting.value = true;

    try {
        const { data } = await adminTenDlcRegistrationClient.detachCampaignPhoneNumber(
            props.campaignId,
            props.phoneNumber
        );

        emit('placed', data);
        visible.value = false;
    } catch (e) {
        toasted.error(catchRequestError(e), { sticky: true });
    } finally {
        submitting.value = false;
    }
};
</script>
